import {common_utils} from "../common/common_utils";

function game_3200()
{

}


game_3200.getWinInfo = function(this1,obj)
{
    if(common_utils.isNull(obj))
    {
      return winInfo;
    }
    let winInfo = "";
    let winInfoTip= "";
    let len = obj.length;
    let winValue = 0;
    let index = 0;
    Object.keys(obj).map(function(key) {
      let subitem = obj[key];
      let bet = 0;
      //let win = 0;
      let odd = 0;
      if(subitem.BetX100)
      {
        bet = subitem.BetX100;
      }
      if(subitem.CashOutX)
      {
        odd = subitem.CashOutX
      }
      if(index > 0)
      {
        winInfo += " + ";
        winInfoTip+= " + ";
      }
      winInfo += " ("+(bet  / 100).toFixed(2)+" x "+ odd +" - "+((bet) / 100).toFixed(2)+")"
      if(len>1)
      {
        winInfoTip += " ("+this1.$t("lang.str_game_bet")+(index+1)+" x "+ this1.$t("lang.str_3200_CashOutX")+(index+1)+" - "+this1.$t("lang.str_game_bet")+(index+1)+")"
      }
      else
      {
        winInfoTip += " ("+this1.$t("lang.str_game_bet")+" x "+ this1.$t("lang.str_3200_CashOutX")+" - "+this1.$t("lang.str_game_bet")+")"
      }

      index++;
    });
    winInfo += " = ";
    winInfoTip+= " = ";
   index = 0;
   Object.keys(obj).map(function(key) {
       let subitem = obj[key];
       let bet = 0;
       let win = 0;
       if(subitem.BetX100)
       {
         bet = subitem.BetX100;
       }
       if(subitem.WinX100)
       {
         win = subitem.WinX100;
       }
       if(index > 0)
       {
         winInfo += " + ";
         winInfoTip+= " + ";
       }
       winInfo += " ("+(win  / 100).toFixed(2)+" - "+((bet) / 100).toFixed(2)+")"
       if(len>1)
       {
         winInfoTip += " ("+this1.$t("lang.str_parachute_money")+(index+1)+" - "+this1.$t("lang.str_game_bet")+(index+1)+")"
       }else
       {
         winInfoTip += " ("+this1.$t("lang.str_parachute_money")+" - "+this1.$t("lang.str_game_bet")+")"
       }

       winValue += win-bet;
       index++;
  });
  winInfoTip += " = "+ this1.$t("lang.tr_game_total_win")
  winInfo += " = " +((winValue) / 100).toFixed(2);
  return [winInfo,winInfoTip];
}

export {
  game_3200
};



// WEBPACK FOOTER //
// ./src/components/esports/game_3200.js